import axios from 'axios';

const axiosInstance = axios.create({
  // baseURL: "http://localhost:5555/api",
  // baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5555/api',
  baseURL: process.env.REACT_APP_API_URL,
  headers: { "Content-Type": "application/json" },
});

export default axiosInstance;